<template>
    <div class="section3">
        <div class="lottery_box" v-show="!showjljl">
            <div class="wap_lottery_box" :style="{'backgroundImage': `url(${require(`../../assets/wap/zh/3-1/3_1frame.png`)})`}"></div>
            <div class="lottery_tit_bg"></div>
            <img class="lottery_tit pc" :src="require(`../../assets/${language}/3-1/3_1tit.png`)" alt="">
            <!-- <img class="lottery_tit wap" :src="require(`../../assets/wap/${language}/3-1/title.png`)" alt=""> -->
            <p class="rule_btn" @click="$emit('openRule')"><i></i><span>{{ i18n('drawrule') }}</span></p>
            <p class="record_btn" @click="openjljl">{{ i18n('drawrecord') }}</p>

            <div class="lottery">
                <!-- <div :class="['lottery_item','choose'+ (i+1),{'active':choose == i+1}]" v-for="(item,i) in lottery">
                    <img :src="item.image" alt="">
                    <p>{{item.name}}</p>
                </div> -->
                <div :class="['selected',{'shining': shining}]"></div>
                <img class="pc" :src="require(`../../assets/${language}/3-1/rewards.png`)" alt="">
                <img class="wap" :src="require(`../../assets/wap/${language}/3-1/rewards.png`)" alt="">
            </div>
            <div class="lottery_chances"><span>*&nbsp;</span>{{i18n('chance')}}：{{ lottery_chances }}</div>
            <div :class="['btns',language]">
                <button :disabled="isSpinning" :class="['btn1',language]" @click="clicklottery()">{{i18n('draw')}}</button>
                <button :class="['btn2',language]" @click="openTask">{{ i18n('getchance') }}</button>
            </div>
        </div>
        <div class="lottery_box lottery_box2" v-show="showjljl" @wheel.stop>
            <div class="lottery_tit_bg"></div>
            <div class="close" @click="showjljl = false"></div>
            <img class="lottery_tit" :src="require(`@/assets/${language}/jljl/jljl.png`)" alt="">
            <div class="lottery lottery2">
                <div class="rewards_area">
                    <p v-for="(item,i) in rewards" :key="i">
                        {{i+1}}.{{ item.prize_name }}&nbsp;&nbsp;&nbsp;
                        <span v-if="item.prize_type == 2">CDK：{{ item.cdk_code }}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['language','lottery_chances','i18n','showWin','win_name'],

    data() {
        return {
            firstin: false,
            choose: 0,//中奖结果id
            lottery:[],//奖品列表
            isSpinning: false, // 防止重复点击
            lastResult: 1, // 记录上次抽奖结果
            showjljl: false,//是否显示抽奖记录
            rewards: [],//奖励记录列表
            shining: false,
        }
    },
    methods: {
        onFirstVisit() {
            this.firstin = true
            this.getLottery();
        },
        openTask() {
            this.$message.error('活動已結束')
            return
            this.$emit('getTaskList')
        },
        getLottery() {
            this.$http.get('MlbbLottery/getPrizeList').then(res => {
                if (res.code == 0) {
                    this.lottery = res.data
                }
            })
        },
        clicklottery() {
            this.$message.error('活動已結束')
            return
            this.$emit('checkLoginAndExecute', this.getLotteryResult);
        },
        async getLotteryResult() {
            // 检查抽奖次数
            if(this.lottery_chances <= 0) {
                this.$message.error(this.i18n('nodraws'))
                return;
            }

            const res = await this.$http.get('MlbbLottery/draw')
            if(res.code == 0) {
                this.shining = true
                // 使用.sync修饰符更新父组件数据
                this.$emit('update:lottery_chances', this.lottery_chances - 1);
                const result = res.data.prize_id
                const prizeData = this.lottery.find(item => item.id === result);
                // 从上次结果开始
                this.choose = this.lastResult;
                // 抽奖结束
                this.lastResult = result;
                this.choose = result;
                // 可以在这里添加抽奖结果的处理逻辑
                console.log('抽奖结果:', result);
                this.$emit('update:win_name', prizeData.name);
                if(res.data.is_win == 1) {
                    if(prizeData.type == 2) {
                        //道具
                        setTimeout(() => {
                            this.shining = false
                            this.$emit('update:showWin', true);
                        },2500)
                    }else {
                        //实物
                        this.$emit('update:log_id', res.data.log_id);
                        setTimeout(() => {
                            this.shining = false
                            this.$emit('update:showSw', true);
                        },1000)
                    }
                }else {
                    this.shining = false
                    this.$message.error(res.msg)
                }
            }else {
                this.$message.error(res.msg)
            }
            setTimeout(() => {
                this.isSpinning = false;
            },2500)
        },
        
        // 计算从起始位置到目标位置需要的步数
        calculateSteps(start, target) {
            if (target >= start) {
                return target - start;
            } else {
                return (10 - start) + target;
            }
        },
        refreshData() {
            this.getLottery();
        },
        openjljl() {
            this.$emit('checkLoginAndExecute', this.getLotteryRewards)
        },
        getLotteryRewards() {
            this.showjljl = true
            this.$http.get('MlbbUser/getLotteryRewards').then(res => {
                if(res.code == 0) {
                    this.rewards = res.data
                }
            })
        },
    },
    watch: {
        language: {
            handler(newLang, oldLang) {
                if (oldLang && newLang !== oldLang) {
                    this.refreshData();
                }
            },
            immediate: true
        }
    }
}
</script>
<style lang="less" scoped>
.section3 {
    width: 100%;
    height: 100%;
    background: url(../../assets/zh/3-1/3_1bg.png) 0 center / cover no-repeat;
    padding-top: 1.2rem;
    position: relative;
    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: url(../../assets/zh/3-1/3_1ren.png) 100% 100% / contain no-repeat;
    }
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 20;
        pointer-events: none;
        background: url(../../assets/zh/3-1/jb.png) center center / cover no-repeat;
    }
}
.lottery_box {
    z-index: 10;
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%) scale(1.1);
    transform-origin: 0 center;
    width: 13.72rem;
    height: 7.33rem;
    background: url(../../assets/zh/3-1/3_1frame.png) 0 0 / 100% 100% no-repeat;

    .lottery_tit_bg {
        width: 6.71rem;
        height: 1.06rem;
        background: url(../../assets/zh/3-1/tit_bg.png) 0 0 / 100% 100% no-repeat;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
    }
    .lottery_tit {
        display: block;
        height: .82rem;
        width: auto;
        margin: -.2rem auto .5rem;
        position: relative;
        z-index: 2;
        &.pc {
            display: block;
        }
        &.wap {
            display: none;
        }
    }
    .rule_btn {
        position: absolute;
        bottom: 1.35rem;
        right: 1.45rem;
        display: flex;
        align-items: center;
        color: #723F31;
        font-size: .2rem;
        font-weight: 700;
        cursor: pointer;
        i {
            width: .19rem;
            height: .3rem;
            margin-right: .05rem;
            background: url(../../assets/zh/3-1/3_1_ruleicon.png) 0 0 / 100% 100% no-repeat;
        }
    }
    .record_btn {
        z-index: 10;
        cursor: pointer;
        position: absolute;
        top: .49rem;
        right: 1.35rem;
        min-width: 1.57rem;
        padding: 0 0.2rem;
        height: .57rem;
        line-height: .57rem;
        text-align: center;
        font-size: .24rem;
        font-weight: 700;
        color: #B04B30;
        white-space: nowrap;
        background: url(../../assets/zh/3-1/3_1_cjjl.png) 0 0 / 100% 100% no-repeat;
        &:active {
            opacity: 0.9;
        }
    }
    .lottery {
        margin-left: 1.3rem;
        width: 11rem;
        height: 4.49rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .selected {
            position: absolute;
            top: -.2rem;
            left: -0.4rem;
            width: 11.8rem;
            height: 4.8rem;
            background: url(../../assets/zh/3-1/selected.png) 0 0 / 100% 100%;
            opacity: 0;
            &.shining {
                animation: shining .5s ease 5 forwards;
            }
        }
        img {
            width: 100%;
            &.pc {
                display: block;
            }
            &.wap {
                display: none;
            }
        }
        .lottery_img {
            width: 10.98rem;
            height: 4.09rem;
        }
        .lottery_item {
            width: 2.12rem;
            height: 1.98rem;
            background-position: center center;
            background-size: 2.1rem 1.98rem;
            background-repeat: no-repeat;
            background-image: url(../../assets/zh/3-1/lottery_item.png);
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-end;
            padding-bottom: .2rem;
            img {
                width: auto;
                height: 1.4rem;
                transform: translateY(0.6rem);
            }
            p {
                width: 100%;
                word-break: break-all;
                height: .24rem;
                font-size: .2rem;
                text-align: center;
                margin-top: 0.5rem;
                color: #fff;
                text-shadow: -1px 0 #B04B30, 0 1px #B04B30, 1px 0 #B04B30, 0 -1px #B04B30;
            }
            &.active {
                &::after {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    content: '';
                    background-position: center center;
                    background-size: 120% 120%;
                    background-repeat: no-repeat;
                    top: 0;
                    left: 0;
                    background-image: url(../../assets/zh/3-1/3_1_SelectedBox.png);
                }
            }
            &.choose1 {
                top: .12rem;
                left: .16rem;
            }
            &.choose2 {
                top: .12rem;
                left: 2.4rem;
            }
            &.choose3 {
                top: .12rem;
                left: 4.6rem;
            }
            &.choose4 {
                top: .12rem;
                left: 6.8rem;
            }
            &.choose5 {
                top: .12rem;
                left: 9rem;
            }
            &.choose6 {
                bottom: .15rem;
                left: 9rem;
            }
            &.choose7 {
                bottom: .15rem;
                left: 6.8rem;
            }
            &.choose8 {
                bottom: .15rem;
                left: 4.6rem;
            }
            &.choose9 {
                bottom: .15rem;
                left: 2.4rem;
            }
            &.choose10 {
                bottom: .15rem;
                left: .16rem;
            }
        }
    }
    .lottery_chances {
        margin-top: .05rem;
        width: 11.37rem;
        margin: 0 auto;
        color: #723F31;
        font-size: 0.2rem;
        font-weight: 700;
        span {
            display: inline-block;
            transform: translateY(.05rem);
        }
    }
    .btns {
        width: 6rem;
        margin: 0 auto;
        transform: translateY(-0.2rem);
        display: flex;
        justify-content: space-between;
        align-items: center;

        button {
            border: none;
            outline: 0;
            background-color: transparent;
            width: 3.07rem;
            height: .87rem;
            padding-bottom: 0.14rem;
            text-align: center;
            font-size: .3rem;
            font-weight: 700;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
            &:active {
                opacity: 0.8;
            }
            &:disabled {
                opacity: 0.8;
            }
            &.btn1 {
                color: #3051B0;
                background: url(../../assets/zh/3-1/3_1_btn1.png) 0 0 / 100% 100% no-repeat;
            }
            &.btn2 {
                color: #B04B30;
                background: url(../../assets/zh/3-1/3_1_btn2.png) 0 0 / 100% 100% no-repeat;
            }
            &.en,
            &.in,
            &.fi {
                font-size: .2rem;
            }
        }
    }
    &.lottery_box2 {
        z-index: 11;
          .close {
            position: absolute;
            top: -0.24rem;   
            right: -0.2rem;
            width: 1.21rem;
            height: 1.21rem;
            background: url(../../assets/zh/1/close.png) 0 0 / 100% 100% no-repeat;
            cursor: pointer;
            transition: all ease .3s;
            -webkit-tap-highlight-color: transparent;
            &:hover {
              transform: scale(1.1);
            }
        }
        .lottery2 {
            padding: .4rem;
            display: block;
            .rewards_area {
                height: 3.9rem;
                overflow-y: auto;
                &::-webkit-scrollbar {
                    width: .12rem;
                }
                &::-webkit-scrollbar-track {
                    width: .05rem;
                    border-top: none;
                    border-bottom: none;
                    background: url(../../assets/zh/track.png) 0.025rem 0 / .05rem 100% no-repeat;
                }
                &::-webkit-scrollbar-thumb {
                    width: .12rem;
                    background-color: #D37966;
                    border-radius: 0.2rem;
                }
            }
            p {
                width: 100%;
                word-break: break-all;
                color: #723F31;
                font-size: .28rem;
                margin-bottom: .2rem;
            }
        }
    }
}

.chance_pop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    z-index: 200;
}

@keyframes shining {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@media screen and (max-width: 751px) {
    .section3 {
       background: url(../../assets/wap/zh/3-1/3_1bg.png) right center / cover no-repeat;
       &::after {
        bottom: unset;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 7.14rem;
        height: 8.97rem;
        background: url(../../assets/wap/zh/3-1/3_1ren.png) 0 0/ 100% 100% no-repeat;
       }
        &::before {
            pointer-events: none;
            background: url(../../assets/wap/zh/3-1/jb.png) center center / cover no-repeat;
        }
    }
    .lottery_box {
        top: unset;
        right: unset;
        bottom: .2rem;
        left: 50%;
        transform: translateX(-50%) scale(1);
        width: 7.18rem;
        height: 9.89rem;
        background: unset;
        padding-top: 0.25rem;
        transform-origin: center 0;
        .wap_lottery_box {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-position: 0 0;
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
        .lottery_tit_bg {
            width: 5.3rem;
            height: .7rem;
            top: 0.3rem;
        }
        .lottery_tit {
            height: .69rem;
            margin: -0.6rem auto 0;
            max-width: 100%;
            transform: translateY(0.4rem);
        }
        &.lottery_box2 {
            bottom: unset;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 7.18rem;
            height: 6.01rem;
            background: url(../../assets/wap/zh/3-1/jljl.png) 0 0 / 100% 100% no-repeat;
            .close {
                top: -0.16rem;
            }
        }
        .rule_btn {
            z-index: 10;
            top: -.5rem;
            right: .2rem;
            bottom: unset;
            writing-mode: unset;
            width: unset;
            padding: 0 .2rem;
            color: #b04b30;
            white-space: nowrap;
            min-width: 1.56rem;
            height: .56rem;
            background: url(../../assets/wap/zh/3-1/record_bg.png) 0 0 / 100% 100% no-repeat;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
            span {
                width: 100%;
                font-size: .24rem;
                text-align: center;
            }
            i {
                display: none;
            }

        }
        .record_btn {
            top: unset;
            right: .8rem;
            bottom: .7rem;
            writing-mode: unset;
            width: unset;
            padding: 0 0.1rem;
            color: #B04B30;
            white-space: nowrap;
            min-width: 1.56rem;
            height: .56rem;
            background: url(../../assets/wap/zh/3-1/record_bg.png) 0 0 / 100% 100% no-repeat;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
        }
        .lottery {
            margin-left: 0.88rem;
            width: 5.4rem;
            height: 7rem;
            margin-top: 1.05rem;
            .selected {
                top: -0.26rem;
                left: -0.27rem;
                width: 6rem;
                height: 7.5rem;
                background: url(../../assets/wap/zh/3-1/selected.png) 0 0 / 100% 100% no-repeat;
            }
            img {
                width: 100%;
                &.pc {
                    display: none;
                }
                &.wap {
                    display: block;
                }
            }
            &.lottery2 {
                height: 4.3rem;
                padding: 0.2rem;
                .rewards_area {
                    height: 4rem;
                    p {
                        font-size: .2rem;
                    }
                }
            }
            .lottery_item {
                width: 1.8rem;
                height: 1.68rem;
                padding-bottom: 0.1rem;
                background-size: 100% 100%;
                // background-image: url(../../assets/wap/zh/3-1/lottery_item.png);
                p {
                    margin: 0;
                    font-size: .16rem;
                    transform: translateY(-0.04rem);
                }
                img {
                    transform: unset;
                    width: 1rem;
                    height: auto;
                }
                &.choose1 {
                    top: 0;
                    left: 0;
                }
                &.choose2 {
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                }
                &.choose3 {
                    top: 0;
                    left: unset;
                    right: 0;
                }
                &.choose4 {
                    top: 1.8rem;
                    left: unset;
                    right: 0;
                }
                &.choose5 {
                    top: unset;
                    bottom: 1.75rem;
                    left: unset;
                    right: 0;
                }
                &.choose6 {
                    top: unset;
                    left: unset;
                    right: 0;
                    bottom: 0;
                }
                &.choose7 {
                    top: unset;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 0;
                }
                &.choose8 {
                    top: unset;
                    bottom: 0;
                    left: 0;
                    right: unset;
                }
                &.choose9 {
                    top: unset;
                    left: 0;
                    bottom: 1.75rem;
                    right: unset;
                }
                &.choose10 {
                    top: 1.8rem;
                    left: 0;
                    right: unset;
                }
            }
        }
        .lottery_chances {
            width: auto;
            padding-left: 0.8rem;
            font-size: .2rem;
            margin-top: 0.3rem;
            position: relative;
            z-index: 2;
        }
        .btns {
           margin: 0;
           position: absolute;
           z-index: 10;
           top: 3.25rem;
           left: 50%;
           transform: translateX(-50%);
           width: 1.62rem;
           display: flex;
           flex-direction: column;
            &::before {
                z-index: -1;
                content: '';
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: -1rem;
                width: 3.68rem;
                height: 3.68rem;
                background: url(../../assets/wap/zh/3-1/draw_bg.png) 0 0 / 100% 100% no-repeat;
            }
            button {
                width: 1.62rem;
                height: 1.62rem;
                padding: 0;
                font-size: .35rem;
                &.zh {
                    padding: 0 0.3rem;
                }
                &.btn1 {
                    color: #B04B30;
                    background: url(../../assets/wap/zh/3-1/3_1_btn1.png) 0 0 / 100% 100% no-repeat;
                    margin-bottom: 0.15rem;
                    &.en,
                    &.in,
                    &.fi {
                        font-size: .3rem;
                    }
                }
                &.btn2 {
                    color: #3051B0;
                    background: url(../../assets/wap/zh/3-1/3_1_btn2.png) 0 0 / 100% 100% no-repeat;
                }
            }
        }
    }
}
</style>